/** @format */

import { useEffect, useState } from 'react';
import { CallLog, CallLogsFilterInput, CallLogUpdateInput } from '../types/callLogs.types';
import { getCallLogs, updateCallLog } from '../services/callLogsService';
import { toast } from 'react-toastify';

export const useCallLogs = (filter?: CallLogsFilterInput, refreshTrigger?: number) => {
  const [data, setData] = useState<CallLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const logsData = await getCallLogs(filter);
        setData(logsData);
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to fetch call logs';
        setError(message);
        toast.error(message);
        console.error('Error fetching call logs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filter, refreshTrigger]);

  const handleUpdateCallLog = async (id: string, updates: CallLogUpdateInput) => {
    try {
      await updateCallLog(id, updates);
      // Refresh the data
      const logsData = await getCallLogs(filter);
      setData(logsData);
      toast.success('Call log updated successfully');
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to update call log';
      toast.error(message);
      console.error('Error updating call log:', err);
    }
  };

  return { data, loading, error, updateCallLog: handleUpdateCallLog };
};
